export default function Header() {
    window.addEventListener('load', function() {
        // Hide the preloader when the page is fully loaded
        var preloader = document.querySelector('.preloader');
        let tl = gsap.timeline({ paused: true });
        tl.to(preloader, { duration: 0.5, opacity: 0 })
        .to(preloader, {  display: 'none' })
        tl.play();
    });

    function resizeNav() {
        // Set the nav height to fill the window
        $("#nav-fullscreen").css({ "height": window.innerHeight });

        // Set the circle radius to the length of the window diagonal,
        // this way we're only making the circle as big as it needs to be.
        var radius = Math.sqrt(Math.pow(window.innerHeight, 2) + Math.pow(window.innerWidth, 2));
        var diameter = radius * 2;
        $("#nav-overlay").width(diameter);
        $("#nav-overlay").height(diameter);
        $("#nav-overlay").css({ "margin-top": -radius, "margin-left": -radius });
    }

    // Set up click and window resize callbacks, then init the nav.
    $(document).ready(function () {
        $("#nav-toggle").click(function () {
            $("#nav-toggle, #nav-overlay, #nav-fullscreen").toggleClass("open");
            if ($("#nav-toggle, #nav-overlay, #nav-fullscreen").hasClass("open")) {
                $("#wrap").removeClass("d-none");
                gsap.set(".logo-header", { zIndex: 1 });
            } else {
                $("#wrap").toggleClass("close");
                gsap.set(".logo-header", { zIndex: 999 });
            }
        });

        $(window).resize(resizeNav);

        resizeNav();

        // window.setTimeout(function () {
        //     $("#nav-toggle").click();
        // }, 1000)

        $(".link").each(function () {
            $(this).on("mouseover", function () {
                $(".container").addClass("hover");
                $(".container-item").removeClass("active");
                $(this).parent().addClass("active");
            }).on("mouseleave", function () {
                $(".container").removeClass("hover");
            });
        });


        $('button').on('click', function () {
            $('body').toggleClass('open');
        });
    });

    // if(document.getElementById('places')){
    //     gsap.set(".logo-header", { filter: 'invert(1)'});
    //     gsap.set("#menu-icon", { background: '#fff'});
    // }

};
